document.addEventListener('DOMContentLoaded', function() {

	let gallerySlider = $('.js-gallery-carousel');

	gallerySlider.slick({
		arrows: true,
		//appendArrows: $('.js-carousel-arrows'),
		dots: false,
		infinite: true,
		mobileFirst: true,
		//centerMode: true,
		slidesToShow: 1,
		fade: true,
		speed: 600,
		cssEase: 'linear',
		// responsive: [
		//   {
		// 	breakpoint: 1024,
		// 	settings: {
		// 		infinite: false,
		// 		centerMode: false,
		// 	  slidesToShow: 3,
		// 	  slidesToScroll: 3,
		// 	  arrows: true,
		// 	}
		//   },
		//   {
		// 	breakpoint: 600,
		// 	settings: {
		// 	  slidesToShow: 2,
		// 	  slidesToScroll: 2,
		// 	}
		//   },
		//   {
		// 	breakpoint: 480,
		// 	settings: {
		// 	  slidesToShow: 1,
		// 	  slidesToScroll: 1,
		// 	}
		//   }
		  // You can unslick at a given breakpoint now by adding:
		  // settings: "unslick"
		  // instead of a settings object
		//]
	});

})